<template>
  <GridPostsPdfThumbnails :category="category" :m-medias="mPageMedias" />
</template>
<script lang="ts" setup>
const { categoryManager, mPageMedias } = inject(INJECT_CATEGORY_PAGE);
const { category } = categoryManager;
</script>
